
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, EventEmitter, Output, inject, Input } from '@angular/core';
import { mat } from '../../../../shared';
import { MenuBarComponent } from "../menu-bar/menu-bar.component";
import { Router } from '@angular/router';
// import { AuthenService } from 'src/app/core/service/authen.service';
// import { mat } from 'src/app/shared/shared';


@Component({
  selector: 'lib-tool-bar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    mat,
    CommonModule,
    MenuBarComponent
]
})
export class ToolBarComponent {
  @Input() menus: any[] = []
  isExpanded = false
  @Output() expanedMenu = new EventEmitter<boolean>()
  router = inject(Router)
  // appToken = inject(ApptokenService)
  // authenSV = inject(AuthenService)
  // constructor() { }

  // ngOnInit(): void {
  // }

  toggleMenu() {
    this.isExpanded = !this.isExpanded
    this.expanedMenu.emit(this.isExpanded)
  }

  
  logout() {
    localStorage.clear()
    this.router.navigate(['/login'])
  }

}
